import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Comment document interface
 */
export interface CommentDocument extends BaseDocument {
  entityType: string
  entityId: string
  content: string
  contentFormat: string
  contentPlainText: string | null
  parentCommentId: string | null
  anchorId: string | null
  createdByName: string | null
  createdByEmail: string | null
  isResolved: boolean
  resolvedAt: number | null
  resolvedBy: string | null
}

/**
 * Comment-specific hooks
 */
const hooks = createEntityHooks<CommentDocument>('comments')

export const useComments = (filter?: Partial<CommentDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { comments: data, isLoading, db }
}

export const useComment = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { comment: data, isLoading }
}

export const useCommentMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createComment: create,
    updateComment: update,
    deleteComment: deleteEntity,
  }
}
